import React, { FC, ReactNode, useMemo } from 'react';
import classNames from 'classnames';

import getClassName from 'src/common/utils/getClassName';
import s from './Card.module.scss';

type Modifier =
  'highlighted'
  | 'hoverEffect'
  | 'instabookDetails'
  | 'loading'
  | 'review'
  | 'reviewShare'
  | 'termsAndCancellation'
  | 'withLargeRightPadding'
  | 'withZeroPadding'
  ;

type CardPropTypes = {
  highlighted?: boolean;
  classNameModifier?: Modifier;
  className?: string;
  children: ReactNode;
  title?: string;
  withGap?: boolean;
  withoutMarginBottom?: boolean;
  withDashedBorderBottom?: boolean;
};

const Card: FC<CardPropTypes> = ({
  highlighted = false,
  children = '',
  className = '',
  classNameModifier = '',
  title,
  withGap = false,
  withoutMarginBottom = false,
  withDashedBorderBottom = false,
}) => {
  const modifiers = useMemo(() => classNames(classNameModifier, {
    highlighted,
    withGap,
    withoutMarginBottom,
    withDashedBorderBottom,
  }), [classNameModifier, highlighted, withGap, withoutMarginBottom, withDashedBorderBottom]);

  return (
    <div className={`${getClassName(s, 'root', modifiers)} ${className}`}>
      {title && (
        <h3 className={s.title}>
          {title}
        </h3>
      )}
      {children}
    </div>
  );
};

export default Card;
